import React, { ReactNode } from 'react';

export type BenefitType = {
	title: ReactNode;
	titleModal: ReactNode;
	text: string;
	textMobile: string;
	modalText: string;
	bgSrc: string;
	bgSrcMobile: string;
};

export const benefitsDb: BenefitType[] = [
	{
		title: (
			<div>
				Вернём деньги за замер <br /> и осмечивание
			</div>
		),
		titleModal: (
			<div>
				Вернём деньги за замер <br /> и осмечивание
			</div>
		),
		text: 'Сделаем точный замер помещения, а на 3-й день подготовим смету',
		textMobile: 'Сделаем точный замер помещения',
		modalText:
			'Сделаем точный замер помещения, а на 3-й день подготовим смету — компенсируем средства за обе услуги',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724416886/fudzi/elbrus/images/landings/rough-work/Кредит 1.png/Кредит 1.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724428823/fudzi/elbrus/images/landings/rough-work/Кредит 1_s.png/Кредит 1_s.png',
	},
	{
		title: (
			<>
				Позаботимся
				<br /> о всех этапах
			</>
		),
		titleModal: <>Позаботимся о всех этапах</>,
		text: 'Подберём все необходимые товары и услуги, оформим доставку',
		textMobile: 'Подберём все необходимые товары и услуги',
		modalText:
			'Подберём все необходимые товары и услуги, оформим доставку и будем рядом на всех этапах ремонта',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724658712/fudzi/elbrus/images/landings/rough-work/Товары и услуги.png/Товары и услуги.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724658792/fudzi/elbrus/images/landings/rough-work/Товары и услуги_s.png/Товары и услуги_s.png',
	},
	{
		title: (
			<div>
				Предоставим надёжных <br />
				мастеров
			</div>
		),
		titleModal: (
			<div>
				Предоставим надёжных <br />
				мастеров
			</div>
		),
		text: 'Мы работаем только с проверенными партнёрами',
		textMobile: 'Проверенные партнёры',
		modalText:
			'Мы работаем только с проверенными партнёрами, где каждый мастер — профессионал своего дела',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724658923/fudzi/elbrus/images/landings/rough-work/Мастера.png/Мастера.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724658923/fudzi/elbrus/images/landings/rough-work/Мастера_s.png/Мастера_s.png',
	},
	{
		title: (
			<div>
				Гарантируем <br /> качество
			</div>
		),
		titleModal: <div>Гарантируем качество</div>,
		text: 'Предоставим годовую гарантию на услуги',
		textMobile: 'Предоставим годовую гарантию на услуги',
		modalText:
			'Предоставим годовую гарантию на услуги. А ещё возможность вернуть любой товар в течение 100 дней, а с Сервисной картой — в течение 1 года',
		bgSrc:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724659032/fudzi/elbrus/images/landings/rough-work/Гарантия.png/Гарантия.png',
		bgSrcMobile:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1724659032/fudzi/elbrus/images/landings/rough-work/Гарантия_s.png/Гарантия_s.png',
	},
];
